export const campaignStatus = {
  draft: 'Rascunho',
  scheduled: 'Agendada',
  sending: 'Em envio',
  paused: 'Pausada',
  completed: 'Concluída',
  cancelled: 'Cancelada',
};

export const deliveryStatus = {
  pending: 'Na fila',
  sending: 'Enviando',
  sent: 'Enviado',
  failed: 'Falhou',
  skipped: 'Não enviado',
  uncertain: 'Envio não confirmado',
};

export const exclusionLabels = {
  invalid_email: 'E-mail inválido ou ausente',
  blocked: 'Contato bloqueado',
  unsubscribed: 'Inscrição cancelada',
  duplicate_email: 'E-mail repetido',
};

export const localDateTime = value => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const pad = number => String(number).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const campaignPayload = form => ({
  title: form.title.trim(),
  subject: form.subject.trim(),
  content: form.content,
  inbox_id: Number(form.inbox_id),
  rate_per_minute: Number(form.rate_per_minute),
  scheduled_at: form.scheduled_at
    ? new Date(form.scheduled_at).toISOString()
    : null,
  audience: {
    mode: form.mode,
    label_ids: form.mode === 'labels' ? form.label_ids : [],
    contact_ids: form.mode === 'contacts' ? form.contact_ids : [],
  },
});

export const campaignError = error => {
  const message = error.response?.data?.error;
  return typeof message === 'string' &&
    !/internal server|exception/i.test(message)
    ? message
    : 'Não foi possível concluir a operação. Confira os dados e tente novamente.';
};

export const dateLabel = value =>
  value
    ? new Date(value).toLocaleString('pt-BR', {
        dateStyle: 'short',
        timeStyle: 'short',
      })
    : 'Sem agendamento';
